import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import axios from 'axios';
import fpodb from '../../../db.json';
import { Accordion, SelectedFiltersComponent, Checkbox, Pagination } from './filter-components';

const safeString = (str) => {
    return encodeURIComponent(str);
}

const Documentation = () => {

    let documentation = document.querySelectorAll('.documentation');

    const documentationConstructor = (id) => {
        Vue.component('documentation-template', {
            data: function() {
                return {
                    data: {
                        currentPage: 1, //current page #
                        totalPages: null, //total returns pages
                        totalResults: null, //total results
                        shownResults: null, //total shown items
                        filtersVisible: null, //are filters visible
                        filterAreaVisible: true,
                        filters: [],
                        products: [],
                        results: [],
                        emailDocs: [], //for emailing
                        savedDocs: [], //bookmarked items
                        savedDocsLabel: null, //label for saved docs,
                        savedDocsOnly: null, //is saved docs only checked?
                        isMobile: null,
                        nextActive: null,
                        prevActive: null,
                        // apiUrl: null, //for api call
                        urlParams: null, //for deeplinking in-browser
                        shareAll: false,
                        query: null, //search query
                        // store: store
                        class: 'documentation',
                        trackingType: 'document'
                    },
                    isLoading: null
                }
            },
            components: {
                'filter-accordion-template': Accordion,
                'selectedFilters': SelectedFiltersComponent,
                'checkbox-item': Checkbox,
                'pagination': Pagination
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
                saved: function() {
                    return store.state.favorites.documentId;
                },
                pageRange: function() {
                    if (this.data.totalResults > 10) {
                        if (this.data.currentPage == 1) {
                            return `1-${this.data.shownResults}`;
                        } else if (this.data.currentPage == this.data.totalPages ) {
                            return `${this.data.totalResults - this.data.shownResults + 1}-${this.data.totalResults}`;
                        } else {
                            return `${(this.data.shownResults * (this.data.currentPage - 1)) + 1}-${this.data.shownResults * this.data.currentPage}`;
                        }
                    } else {
                        return this.data.shownResults;
                    }
                },
                page: function() {
                    return this.data.currentPage;
                },
                lang: function() {
                    return store.state.currentLang;
                }
            },
            watch: {
                saved: function() {
                    this.data.savedDocs = this.saved;

                    // remove saved only filter if no saved items
                    if (this.saved.length == 0) {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf('savedDocuments');
                        if (index > -1) {
                            this.data.filters.splice(index,1);
                        }
                    }
                },
                computedIsMobile: function() {
                    this.data.isMobile = this.computedIsMobile;
                    this.data.filtersVisible = !this.computedIsMobile ? true : this.data.filtersVisible;
                },
                "data.filters": function() {
                    this.addLoading();
                    this.getResults(); // handle api call
                    // this.updateHistory(); // handle history record
                    // this.data.currentPage = 1; //reset page to 1
                    this.data.emailDocs = [];
                    
                    // check for if brand is selected
                    let brands = this.data.filters.filter(el => {
                        return el.type == "brand";
                    }).map(el => {
                        return el.value;
                    });

                    if (brands.length > 0) {
                        this.populateProducts(brands); 
                    } else {
                        //if not brand selected, empty the products array
                        this.data.products = []; 
                        // remove selected product filters
                        this.data.filters.filter(el => {
                            return el.type == "product"
                        }).forEach(item => {
                            this.removeFilter(this.data.class, item.value);
                        });
                    }

                    // set savedDocsOnly value
                    let savedOnly = this.data.filters.find(item => {
                        return item.type == "savedDocuments";
                    })
                    this.data.savedDocsOnly = savedOnly ? savedOnly.value : null;

                },
                page: function() {
                    if (this.data.currentPage == 1) {
                        this.data.nextActive = true;
                        this.data.prevActive = false;
                    } else if (this.data.currentPage == this.data.totalPages) {
                        this.data.nextActive = false;
                        this.data.prevActive = true;
                    } else {
                        this.data.nextActive = true;
                        this.data.prevActive = true;
                    }

                    // this.getResults();
                    // this.updateHistory();
                },
                "data.totalResults": function() {
                    this.initPages();
                }
                
            },
            methods: {
                toggleFilters() {
                    if (this.data.isMobile) {
                        this.data.filtersVisible = !this.data.filtersVisible;
                    }
                },
                updateFilters(el, e, type) {
                    if (el !== this.data.class) {
                        return; //abort if not documentation module
                    }
                    var type = type;
                    var value = safeString(e.currentTarget.value);
                    var label = e.currentTarget.parentNode.innerText;
                    var checked = e.currentTarget.checked;
                    this.data.currentPage = 1;

                    if (checked) {
                        if (type !== "savedDocuments") {
                            this.data.filters = [...this.data.filters, {"value": value, "type": type, "name": label}];
                        } else {
                            this.data.filters = [...this.data.filters, {"value": checked, "type": type, "name": label}];
                        }
                    } else {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf(value);
                        this.data.filters.splice(index,1);
                    }
                    console.log(this.data.filters)
                },
                // removes specific filter
                removeFilter(el, value, type) {
                    if (el !== this.data.class) {
                        return;
                    }
                    let index = this.data.filters.map((e) => {
                        return e.value
                    }).indexOf(value);
                    this.data.filters.splice(index,1);
                },
                // clears filters
                removeAll() {
                    this.data.filters = [];
                    this.data.currentPage = 1; //reset page to 1
                },  
                populateProducts(brands) {
                    let brandStr = decodeURIComponent(brands.join('|'));
                    let apiUrl = `/api/GetDocumentProductsByBrand`;
                    // let apiUrl = "http://localhost:3003/productsByBrand"; //from json-server
                    let self = this;

                    axios.get(apiUrl, {
                            params: {
                                brand: brandStr,
                                lang: this.lang
                            }
                        })
                        .then(function(response) {
                            self.data.products = response.data.results;  
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                },
                getUrl() {
                    let savedParams = this.data.savedDocs.toString();
                    let query= this.data.query;
                    let productParams = this.data.filters.filter(item => {
                        return item.type == "product"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let langParams = this.data.filters.filter(item => {
                        return item.type == "lang"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let brandParams = this.data.filters.filter(item => {
                        return item.type == "brand"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let docTypeParams = this.data.filters.filter(item => {
                        return item.type == "docType"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedDocuments";
                        })
                        if (savedOnly) {
                            return savedOnly.value;
                        } else {
                            return false;
                        }
                    }

                    let pageParams = this.data.currentPage;
                    this.data.urlParams = "?"
                    if (query) {
                        this.data.urlParams +="q="+encodeURIComponent(query);
                    }
                    this.data.urlParams += `${productParams !== "" ? "&product=" + productParams : ""}${langParams !== "" ? "&lang=" + langParams : ""}${brandParams !== "" ? "&brand=" + brandParams : ""}${docTypeParams !== "" ? "&docType=" + docTypeParams : ""}&savedDocuments=${savedDocumentsTrueParams()}&page=${pageParams}`;

                },

                didYouMean(e) {
                    let didyoumeanEl = document.querySelectorAll('.peoplealsosearchedfor');
                    let didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__peoplealsosearchedfor');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));
                    didyoumeanEl = document.querySelectorAll('.didyoumean');
                    didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__didyoumean');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));
                    let query;
                    if (e.target) {
                        query = e.target.innerText;
                    } else {
                        query = e;
                    }
                    this.data.query = query;

                    document.querySelector('.hero-center__search-input').value = query;
                    this.addLoading();
                    this.getResults(e);
                },
                addLoading() {
                    this.isLoading = true;

                    let inputField = document.querySelector('.hero-center__search-input-container');
                    if (inputField)
                        inputField.classList.add('loading');
                },
                removeLoading() {
                    this.isLoading = false;

                    let inputField = document.querySelector('.hero-center__search-input-container');
                    if (inputField)
                        inputField.classList.remove('loading');
                },
                getResults(query) {

                    this.data.query = query === null ? null : query ? query : this.data.query;
                    this.data.currentPage = query ? 1 : this.data.currentPage;

                    this.getUrl();
                    let baseUrl = window.documentAPIUrl;
                    let apiUrl = `${baseUrl}${baseUrl.indexOf('?') > -1 ? '' : '?'}`;
                    // let apiUrl = "http://localhost:3003/documentation"; //from json-server
                    // let apiUrlTest = "http://localhost:3003/documentationTest"; //from json-server

                    let self = this;

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedDocuments";
                        })
                        if (savedOnly) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    var product = [];
                    var lang = [];
                    var brand = [];
                    var docType = [];

                    this.data.filters.map((item) => {
                        switch(item.type) {
                            case "product":
                                product.push(item.value);
                                break;
                            case "lang":
                                lang.push(item.value);
                                break;
                            case "brand":
                                brand.push(item.value);
                                break;
                            case "docType":
                                docType.push(item.value);
                                break;
                            default:
                                return;
                        }
                    });

                    let productStr = decodeURIComponent(product.join('|'));
                    let langStr = decodeURIComponent(lang.join('|'));
                    let brandStr = decodeURIComponent(brand.join('|'));
                    let docTypeStr = decodeURIComponent(docType.join('|'));

                    let axiosParams = {
                        q: this.data.query ? this.data.query : null,
                        saved: (this.data.savedDocs.join('|')) == "" ? null : this.data.savedDocs.join('|').charAt(0) == "," ? this.data.savedDocs.join('|').slice(1) : this.data.savedDocs.join('|'), //@TODO make this less insane. Send NULL if empty string. Remove leading comma if present.
                        product: productStr == "" ? null : productStr,
                        language: langStr == "" ? null : langStr,
                        brand: brandStr == "" ? null : brandStr,
                        docType: docTypeStr == "" ? null : docTypeStr,
                        savedDocuments: savedDocumentsTrueParams(),
                        page: this.data.currentPage,
                    }

                    var searchTerm = this.data.query;

                    axios.get(apiUrl, {
                            params: {
                                ...axiosParams
                            }
                        })
                        .then(function(response) {
                            ///
                            /// Did you mean query logic from episerver find:
                            ///
                            let didyoumeanEl, didyoumeanContainer;
                            if (response.data.results.length == 0) {
                                didyoumeanEl = document.querySelectorAll('.didyoumean');
                                didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__didyoumean');
                                
                            }
                            else {

                                didyoumeanEl = document.querySelectorAll('.peoplealsosearchedfor');
                                didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__peoplealsosearchedfor');
                            }

                            if (response.data.didYouMean && response.data.didYouMean.length > 0) 
                            {
                                let allElements = [];
                                response.data.didYouMean.forEach(dym => {
                                    let anchorElement = document.createElement('a');
                                    anchorElement.href="#";
                                    anchorElement.innerText = dym;
                                    anchorElement.addEventListener("click", function (e) {
                                        e.stopPropagation();
                                        self.didYouMean(anchorElement.innerText);
                                    });
                                    allElements.push(anchorElement);
                                });

                                //clear out all previous elements
                                didyoumeanEl.forEach(parent => {
                                    while (parent.firstChild) {
                                        parent.removeChild(parent.firstChild);
                                    }
                                });
                               
                                for (let i = 0; i<allElements.length; i++) {
                                    didyoumeanEl.forEach(el => el.append(allElements[i]));
                                    if (i + 1 < allElements.length) {
                                        var commaEl = document.createElement('span');
                                        commaEl.style.paddingLeft = "7px";
                                        didyoumeanEl.forEach(el => el.append(commaEl));
                                    }
                                }            
                                didyoumeanContainer.forEach(element => element.classList.add('show'));

                            } else {
                                didyoumeanContainer.forEach(element => element.classList.remove('show'));
                            }
                            ///
                            /// End of did you mean query logic
                            ///

                            // GTM TAGGING
                            if (searchTerm && searchTerm.length > 0 && 
                                window.dataLayer[window.dataLayer.length-1].event != "search-results" // hack to avoid double entry.  this runs twice for some reason
                                ) { // only push if this is a query, not a filter
                                window.dataLayer.push( {
                                    event: "search-results",
                                    type: "documentation",
                                    category: "Search",
                                    action: searchTerm,
                                    label: response.data.totalResults,
                                });
                            }

                            // SET RESULTS
                            self.data.results = response.data.results;  
                            self.data.totalResults = response.data.totalResults;
                            self.data.shownResults = response.data.results.length;
                            self.data.trackId = response.data.trackId;
                            self.removeLoading();

                        })
                        .catch(function(error) {
                            console.log(error);
                            self.removeLoading();
                        });
                },
                changePage(dir) {
                    if (dir == "prev" && this.data.currentPage !== 1) {
                        this.data.currentPage--;
                    } else if (dir == "next" && this.data.currentPage !== this.data.totalPages) {
                        this.data.currentPage++;
                    } else {
                        return;
                    }

                    EventBus.$emit('scroll-to-top', this.data.class);
                    this.addLoading();
                    this.getResults();
                },
                updateEmailDocs(data) {
                    let item = this.data.emailDocs.find(item => {
                        return item.id == data.id;
                    });

                    if (!item) {
                        this.data.emailDocs = [...this.data.emailDocs, data];
                    } else {
                        this.data.emailDocs.splice(this.data.emailDocs.indexOf(item),1);
                    }
                },
                //update history record when filters change
                updateHistory() {
                    this.getUrl();
                    let url = `${window.location.pathname}${this.data.urlParams}`;
                    history.pushState("","",url);
                },
                // handle deep linking on history change
                deeplink() {
                    let didyoumeanEl = document.querySelectorAll('.peoplealsosearchedfor');
                    let didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__peoplealsosearchedfor');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));
                    didyoumeanEl = document.querySelectorAll('.didyoumean');
                    didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__didyoumean');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));


                    let params = window.location.search.substr(1).split("&").filter(item => {
                        return item != ""
                    });

                    var initFilters = [];
                    let page;

                    params.forEach(param => {
                        let type = param.slice(0, param.indexOf('='));
                        let content = param.slice(param.indexOf('=') + 1);

                        let entry = {}
                        if (type == "page") {
                            page = parseInt(content);
                        } else if (type == "savedDocuments") {
                            if (content == "false" || content == false) {
                                return;
                            } else {
                                entry = {
                                    "type": type,
                                    "value": true,
                                    "name": this.data.savedDocsLabel
                                }

                                initFilters = [
                                    ...initFilters,
                                    entry
                                ]
                            }
                        } else if (content.indexOf(',') > -1) {
                            let contentArray = content.split(',');
                            contentArray.forEach(item => {
                                entry = {
                                    "type": type,
                                    "value": item,
                                    "name": decodeURIComponent(item)
                                }

                                initFilters = [
                                    ...initFilters,
                                    entry
                                ]
                            });
                        } else if (type.toLocaleLowerCase() == "manuals") {
                            entry = {
                                "type": "docType",
                                "value": "Manuals%20%26%20Guides",
                                "name": "Manuals & Guides"
                            }

                            initFilters = [
                                ...initFilters,
                                entry
                            ]
                        }
                        else if (type.toLocaleLowerCase() != "manuals") {
                            entry = {
                                "type": type,
                                "value": content,
                                "name": decodeURIComponent(content)
                            }

                            initFilters = [
                                ...initFilters,
                                entry
                            ]
                        }

                        this.data.filters = initFilters;
                    });

                    if (page)
                        this.data.currentPage = page;

                },
                scrollToTop(el) {
                    if (el !== this.data.class) {return;}
                    let top = this.$el.querySelector('.documentation__area-cards').getBoundingClientRect().top + window.scrollY - 100;
                    setTimeout(function() {
                        window.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    }, 500);
                },
                initPages() {
                    // based on total result count, divide by 10 to get total pages needed
                    // math ceil to round up
                    // set active for prev/next based on current page
                    this.data.totalPages = Math.ceil(this.data.totalResults / 10);
                    this.data.prevActive = this.data.currentPage !== 1 ? true : false;
                    this.data.nextActive = this.data.currentPage !== this.data.totalPages ? true : false;
                },
                init() {
                    this.data.isMobile = store.state.isMobile;
                    this.data.savedDocs = store.state.favorites.documentId[0] == "" ? store.state.favorites.documentId.slice(1) : store.state.favorites.documentId;
                    this.data.filtersVisible = this.data.isMobile ? false : true; //init show/hide filters if/is mobile
                    
                    // listen for filter updates in children
                    EventBus.$on('updateFilters', (el, e, type) => {
                        this.updateFilters(el, e, type);
                    });
                    EventBus.$on('remove-filter', (el, value, type) => {
                        this.removeFilter(el, value, type);
                    });
                    EventBus.$on('change-page-to', (el, num) => {
                        if (el !== this.data.class) {return;};
                        this.data.currentPage = num;
                        this.addLoading();
                        this.getResults();
                    });
                    EventBus.$on('email-docs', (data) => {
                        this.updateEmailDocs(data);
                    });
                    EventBus.$on('internal-search', (value, type) => {
                        if (type == "documentation") {
                            //this.updateHistory(value);
                            let didyoumeanEl = document.querySelectorAll('.peoplealsosearchedfor');
                            let didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__peoplealsosearchedfor');
                            didyoumeanContainer.forEach(element => element.classList.remove('show'));
                            didyoumeanEl = document.querySelectorAll('.didyoumean');
                            didyoumeanContainer = document.querySelectorAll('.hero-center__search-input-container__didyoumean');
                            didyoumeanContainer.forEach(element => element.classList.remove('show'));
                            this.addLoading();
                            this.getResults(value);
                        }
                    });
                    EventBus.$on('scroll-to-top', (el) => {
                        this.scrollToTop(el);
                    });

                    // init results
                    this.data.results = window.initialDocumentationApiResults.results;
                    this.data.totalResults = window.initialDocumentationApiResults.totalResults;
                    this.data.shownResults = window.initialDocumentationApiResults.results.length;
                    // this.data.results = fpodb.documentation.results;
                    // this.data.totalResults = fpodb.documentation.totalResults;
                    // this.data.shownResults = fpodb.documentation.results.length;
                    
                    // hide filters if less then 10 initial results
                    this.data.filterAreaVisible = parseInt(this.data.totalResults) <= 10 ? false : true;

                    // enable "share all" if 5 of less results
                    this.data.shareAll = parseInt(this.data.totalResults) <= 5 ? true : false;
                    window.onpopstate = () => {
                         this.deeplink();
                    }

                    if (window.manualsAndGuidesFilter && window.hasManuals) {
                        this.data.filters = [...this.data.filters, {"value": window.manualsAndGuidesFilterValue, "type": "docType", "name": window.manualsAndGuidesFilterName}];
                    }
                }
            },
            mounted() {
                this.init();
                this.initPages();
                // for deeplinking
                // if (window.location.search) {
                //     this.$nextTick(() => {
                //         this.deeplink();
                //     });
                // }
            },
        });

        Vue.component('doc-products', {
            props: ['data', 'category'],
            data: function() {
                return {
                    type: "product"
                }
            },
            components: {
                'checkbox-item': Checkbox
            },
            template: `
            <div class="documentation__products-content">
                <checkbox-item v-for="(productItem, i) in data.products" :key=i :type="type" :label="productItem.value" :value="productItem.key" :data="data" :category="category"/>
            </div>
            `,
            methods: {
            },

            mounted() {

            }
        });
        
        // results list
        Vue.component('doc-results-list', {
            props: ['data', 'isLoading'],
            data: function() {
                return {
                    type: "product"
                }
            },
            template: `
            <div class="documentation__cards-content" :data="data">
                <doc-results-item v-for="(result, index) in data.results" :content="result" :isSelected="isSelected(result)" :key="result.id" :data="data" :isLoading="isLoading" />
            </div>
            `,
            methods: {
                isSelected(result){
                    return this.data.emailDocs.find(i => i.id == result.id) !== undefined;
                }
            },

            mounted() {

            }
        });

        // single results item
        Vue.component('doc-results-item', {
            props: ['data', 'content', 'isSelected', 'isLoading'],
            data: function() {
                return {
                    isChecked: this.isSelected,
                    isBookmarked: false,
                    id: null,
                    seeAll: null, //is "see all" feature enabled,
                    seeAllOpen: null,
                    seeAllLabel: null,//label
                    moreContent: null,
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites.documentId;
                },
                encodedUrl: function() {
                    return encodeURIComponent(this.content.url);
                },
                newTabLink: function() {
                    return this.content.url ? this.content.url.replace('download=true', 'download=false') : null;
                },
                tagMetaBody: function() {
                    return JSON.stringify({
                        "type": "document", 
                        "category": this.content.eyebrow.split("|")[0].trim(),
                        "label": this.content.name, 
                        "productLine": this.content.details, 
                        "language": this.content.language,
                        "documentId": this.content.documentId
                    })
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                },
                "data.emailDocs": function() {
                    if(this.data.emailDocs.length === 0){
                        this.isChecked = false;
                    }
                },
                "content": function() {
                    // update id when content changes
                    this.$nextTick(() => {
                        this.id = this.$refs.bookmark.dataset.documentId;
                        this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                    })
                },
                "seeAll": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                },
                "seeAllOpen": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                }
            },
            template: `
            <div class="doc-card doc-card--checkbox" :class="{'hide-bookmark': (data.savedDocsOnly === true) && (isBookmarked === false)}" data-tag-trigger="click" :data-tag-meta='tagMetaBody'>
                <div class="doc-card__wrapper">
                    <div class="doc-card__row">
                        <div class="doc-card__area doc-card__area-checkbox">
                        <div class="checkbox">
                                <label class="checkbox__label">
                                    <input type="checkbox" class="checkbox__input" :value="content.id" v-on:change="emailDoc" v-model="isChecked" :checked="isChecked" data-tag-trigger="click" data-tag-meta='{"type": "document", "action": "Select"}'>
                                    <span class="checkbox__checkmark"></span>
                                </label>
                            </div>
                        </div>
                        
                        <div class="doc-card__area doc-card__area-info">
                            <div class="doc-card__area doc-card__area-left">
                                <div class="doc-card__eyebrow">
                                    <span class="doc-card__eyebrow__details" ref="seeAllContent">{{content.eyebrow}}</span>
                                    <span class="doc-card__subtitle-more" v-if="seeAll && seeAllOpen">\{{moreContent}}</span> 
                                    <a href="#" v-on:click.prevent="toggleSeeAll" v-if="seeAll">\{{seeAllLabel}}</a>
                                </div>
                                <a :href="newTabLink" class="doc-card__title" target="_blank" data-tag-trigger="click" data-tag-meta='{"type": "document", "action": "Preview"}'>
                                    {{content.name}}
                                </a>
                                <!--
                                <span class="doc-card__subtitle">
                                    <span class="doc-card__subtitle-content" ref="seeAllContent">
                                    {{content.details}}
                                    </span> 
                                    <span class="doc-card__subtitle-more" v-if="seeAll && seeAllOpen">\{{moreContent}}</span> <a href="#" v-on:click.prevent="toggleSeeAll" v-if="seeAll">\{{seeAllLabel}}</a> | {{content.language}}
                                </span> 
                                -->
                            </div>
                            <div class="doc-card__area doc-card__area-right">
                                <a class="doc-card__icon doc-card__icon-download" :href="content.url" data-tag-trigger="click" data-tag-meta='{"type": "document", "action": "Download"}'></a>
                                <a class="doc-card__icon doc-card__icon-email" :href="'mailto:?subject=Badger%20Meter%20Document%20Links&body=' + encodeURIComponent(content.name) + ': ' + this.encodedUrl" data-tag-trigger="click" data-tag-meta='{"type": "document", "action": "Email"}'></a>
                                <a class="doc-card__icon doc-card__icon-bookmark" :data-document-id="content.id" ref="bookmark" v-on:click="handleBookmark" :class="{active: isBookmarked}" data-tag-trigger="click" data-tag-meta='{"type": "document", "action": "Favorite"}'></a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            `,
            methods: {
                emailDoc() {
                    EventBus.$emit('email-docs', {"name": this.content.name, "url": this.content.url, "id": this.content.id});
                },
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: "documentId",
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                },
                toggleSeeAll() {
                    this.seeAllOpen = !this.seeAllOpen;
                },
                initSeeAll() {
                    if (this.$refs.seeAllContent) {
                        //let details = this.$refs.seeAllContent.innerHTML.split(/[,;]+/);
                        let details = this.$refs.seeAllContent.innerHTML.replace(" ; ", ", ").split(/[,]+/);
                        this.seeAll = details.length > 3 ? true : false;

                        let truncatedDetails = details.slice(0,3).join().replace(/ ,/g, ',');;
                        let moreDetails = details.slice(3).join().replace(/ ,/g, ',');

                        this.moreContent = moreDetails;
                        this.$refs.seeAllContent.innerHTML = `${truncatedDetails}${moreDetails == "" ? '' : ','}`;
                    }
                }
            },
            mounted() {
                this.id = this.$refs.bookmark.dataset.documentId;
                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                this.initSeeAll();

                let self = this;
                this.$nextTick(() => {
                    let trackId = self.data.trackId;

                    if (trackId) {
                        let hitId = self.content.hitId;
                        let query = self.data.query;
                        let url = `/api/SearchHit?q=${encodeURIComponent(query)}&h=${encodeURIComponent(hitId)}&t=${encodeURIComponent(trackId)}`
                        let allAnchors = self.$el.querySelectorAll('a');
                        allAnchors.forEach(el => el.addEventListener('click', (e) => 
                            axios.get(url)
                            .then(function(response) {
                            })
                        ));
                    }
                });

            }
        });

        Vue.component('email-docs', {
            props: ['data'],
            data: function() {
                return {
                    mailto: null,
                    // mailtoAll: null
                }
            },
            watch: {
                "data.emailDocs": function() {
                    let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                    this.data.emailDocs.forEach(item => {
                        mailto = `${mailto}${encodeURIComponent(item.name)}: ${encodeURIComponent(item.url)}%0D%0A`;
                    });
                    this.mailto = mailto;
                }
            },
            methods: {
                // shareAll() {
                //     let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                //     this.data.results.forEach(item => {
                //         mailto = `${mailto}${item.name}: ${item.url}%0D%0A`;
                //     });
                //     this.mailtoAll = mailto;
                // }
            },
            mounted() {
                // if (parseInt(this.data.totalResults) <= 5) {
                //     this.shareAll();
                // }
            }
        });

        new Vue({
            el: `.documentation-${id}`,
            store: store
        }).$mount(`.documentation-${id}`, true);
    }

    if (documentation.length > 0) {
        documentation.forEach((item, index) => {
            item.classList.add(`documentation-${index}`);
            documentationConstructor(index);
        })
    }

    // window.seeLessLabel = "see less";
    // window.seeAllLabel = "see more";

}

export default Documentation;
